import React, { useState, useEffect, createContext  } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../css/form.css';
import CreateTableNumber from "./create/createTableNumber";
import UpdateTableNumber from "./update/updateTableNumber";

const tableNumberContext = createContext();

function TableNumber() {

  const [TableNumberList, setTableNumberList] = useState([]);
  const [ShowTableNumber, setShowTableNumber] = useState([]);
  const [TableNumberData, setTableNumberData] = useState([]);

  const [show, setShow] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);

  const handleCloseUpdate = () => setShowUpdate(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const Search = event => {
    const { name, value } = event.target;
    if(value){
      var results = [];
      results = TableNumberList.filter((data) => {
          return data.TableNumber.toLowerCase().includes(value.toLowerCase())
      });
      if (results) 
      setShowTableNumber(results);
      else 
      setShowTableNumber(TableNumberList);
    } else 
      setShowTableNumber(TableNumberList);
  }

  const openUpdate = (TableID, TableNumber) => {
    var list = [];
    list.push({
      TableID: TableID,
      TableNumber: TableNumber
    });
    setTableNumberData(list);
    setShowUpdate(true);
  };
  
  useEffect(() => {
    let userData = localStorage.getItem("tableNumberData");
    if (userData) {
      let tablelist = JSON.parse(userData);
      setTableNumberList(tablelist);
      setShowTableNumber(tablelist);
    }
  }, []);

  return (
    <tableNumberContext.Provider value={{TableNumberList, setTableNumberList, TableNumberData, setTableNumberData}}>
      <div className="formContent">
        <CreateTableNumber show={show} onClick={handleClose}/>
        <UpdateTableNumber show={showUpdate} onClick={handleCloseUpdate}/>
        <div className="Header">
          <div className="title">
              <span>ຂໍ້ມູນ ເລກໂຕະ</span>
          </div>
          <div className="txtSearch">
            <input placeholder="ຄົ້ນຫາ" onChange={(e) => Search(e)} />
            <button className="btn btn-primary" onClick={handleShow} >ເພີ່ມ</button>
          </div>
        </div>
        <div className="Body">
          <table className="styled-table">
            <thead>
              <tr key={1}>
                <th>ລ/ດ</th>
                <th>ເລກໂຕະ</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {
                ShowTableNumber && ShowTableNumber.map((x, y) => {
                    return (
                      <tr key={y}>
                        <td >{y + 1}</td>
                        <td >{x.TableNumber}</td>
                        <td >
                          <button className="btn btn-secondary" value={x.TableID} type="button" onClick={() => openUpdate(x.TableID, x.TableNumber)}>ແກ້ໄຂ</button>
                        </td>
                      </tr>
                    )
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </tableNumberContext.Provider>
  );
};

export {tableNumberContext};
export default TableNumber;
